<template>
  <GModal ref="modalSelectProduct" class="modal--select-product">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/back.svg" @click.prevent="closeModal" />
      </button>
      <h2 class="modal-heading modal-heading__header">{{ headingTitle }}</h2>
    </div>

    <div slot="body">
      <div v-if="!screen.isDesktop && !isSeeAll" class="parent-progress">
        <span class="counter-progress">1 of 3</span>
        <div class="progress">
          <div class="progress-bar" style="width: 30%"></div>
        </div>
      </div>
      <form
        class="form-search-product"
        :class="{
          'recently-bought-empty':
            !$SO.size(recentlyBought) && !$SO.size(trendingProducts) && isLoadingFinishRecentlyBought,
        }"
        @scroll="onScroll"
        @submit.prevent
      >
        <div
          v-if="screen.isDesktop || (!screen.isDesktop && !isSeeAll)"
          ref="productInlineWrapper"
          class="form-group product-inline-wrapper"
          :class="{ 'is-loading': processingSearchProduct }"
        >
          <template v-if="screen.isDesktop">
            <div class="heading-new">
              <h2 class="modal-heading-new">Yuk, Tulis Review!</h2>
              <p class="text-helped-new">
                Bagikan pengalamanmu dan dapatkan +20 SP <br />
                untuk setiap Trusted Review yang kamu bagikan!
              </p>
            </div>
          </template>
          <template v-else>
            <div class="heading-new">
              <h2 class="modal-heading-new">Yuk, Tulis Review!</h2>
              <p class="text-helped-new">
                Bagikan pengalamanmu dan dapatkan <b>+20 SP</b> untuk setiap Trusted Review yang kamu bagikan!
              </p>
            </div>
            <div class="img-heading">
              <img
                src="/assets/img/banner-review-create.svg"
                class="icon icon__heading-mobile"
                alt="icon-heading-mobile"
              />
            </div>
          </template>

          <div v-if="screen.isDesktop" class="form-group-search">
            <img src="/assets/img/icons/input-search.svg" class="form-group-search__icon" alt="icon-search" />
            <input
              v-model="querySearchProduct"
              type="text"
              name="product"
              class="form-control form-control-search"
              placeholder="What do you want to review?"
              autocomplete="off"
              @keyup="search"
            />

            <div
              v-if="processingSearchProduct || $SO.size(searchProduct) || hasSearched"
              class="product-inline-listing"
            >
              <div v-if="processingSearchProduct" class="loading-spinner">
                <div class="spinner"></div>
                <p>Loading...</p>
              </div>
              <template v-else-if="$SO.size(searchProduct)">
                <template v-for="(product, key) in searchProduct">
                  <div
                    v-if="product"
                    :key="key"
                    class="product-inline"
                    :class="{ disabled: product.is_reviewed === true }"
                  >
                    <a href class="product-inline-container" @click.prevent="selectSearchProduct(product)">
                      <img
                        v-if="product.images.length"
                        :src="product.images[0].url"
                        class="product-inline__img"
                        onerror="this.src='/assets/img/dummy_product.svg'"
                        :alt="product.brand.name"
                      />
                      <img v-else src="/assets/img/dummy_product.svg" class="product-inline__img" alt="SOCO" />
                      <div class="product-inline-content">
                        <h5 v-if="product.brand" class="product-inline__manufacture-name">
                          {{ product.brand.name }}
                        </h5>
                        <p class="product-inline__product-name">
                          {{ product.name }}
                        </p>
                        <div class="card-rating">
                          <div class="rating--uniform timeline-review">
                            <div
                              class="rate-star--uniform"
                              :class="
                                'rate-star--uniform-' +
                                $options.filters.rating(product.review_stats.average_rating) * 10
                              "
                            >
                              <span></span>
                              <span></span>
                              <span></span>
                              <span></span>
                              <span></span>
                            </div>
                            <span class="product-inline__total-review"
                              >({{ $options.filters.cnvrtNumberToK(product.review_stats.total_reviews) }})</span
                            >
                          </div>
                        </div>
                      </div>
                    </a>
                    <div class="trusted-review">
                      <div class="trusted-review">
                        <img
                          v-if="user.is_expert_reviewer"
                          src="/assets/img/expert-review-check-icon.svg"
                          height="18"
                          width="18"
                          alt="icon-expert"
                        />
                        <img
                          v-else-if="
                            defineReviewData(product).combinations.some(
                              (combination) => combination.is_verified_purchase
                            )
                          "
                          src="/assets/img/icon-shopper.svg"
                          height="18"
                          width="18"
                          alt="shopper"
                        />
                      </div>
                    </div>
                    <div v-if="product.is_reviewed === true" class="has-reviewed">
                      <span class="red text-uppercase">REVIEWED</span>
                    </div>
                  </div>
                </template>
                <infinite-loading @infinite="infiniteHandler">
                  <div slot="no-more"></div>
                  <div slot="no-results"></div>
                  <div slot="spinner">
                    <GLoaderSpin text="Load product.." />
                  </div>
                </infinite-loading>
              </template>
              <div v-else-if="hasSearched && !$SO.size(searchProduct)" class="no-results-search">
                <div class="no-results-icon">
                  <img src="/assets/img/icon-no-result-search.svg" alt="no result" />
                </div>
                <p class="no-results-text">Maaf, tidak ada produk yang ditemukan</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!screen.isDesktop && !isSeeAll" class="form-group-search">
          <img src="/assets/img/icons/input-search.svg" class="form-group-search__icon" alt="icon-search" />
          <input
            v-model="querySearchProduct"
            type="text"
            name="product"
            class="form-control form-control-search"
            placeholder="What do you want to review?"
            autocomplete="off"
            @keyup="search"
          />

          <div v-if="processingSearchProduct || $SO.size(searchProduct) || hasSearched" class="product-inline-listing">
            <div v-if="processingSearchProduct" class="loading-spinner">
              <div class="spinner"></div>
              <p>Loading...</p>
            </div>
            <template v-else-if="$SO.size(searchProduct)">
              <template v-for="(product, key) in searchProduct">
                <div
                  v-if="product"
                  :key="key"
                  class="product-inline"
                  :class="{ disabled: product.is_reviewed === true }"
                >
                  <a href class="product-inline-container" @click.prevent="selectSearchProduct(product)">
                    <img
                      v-if="product.images.length"
                      :src="product.images[0].url"
                      class="product-inline__img"
                      onerror="this.src='/assets/img/dummy_product.svg'"
                      :alt="product.brand.name"
                    />
                    <img v-else src="/assets/img/dummy_product.svg" class="product-inline__img" alt="SOCO" />
                    <div class="product-inline-content">
                      <h5 v-if="product.brand" class="product-inline__manufacture-name">{{ product.brand.name }}</h5>
                      <p class="product-inline__product-name">{{ product.name }}</p>
                      <div class="card-rating">
                        <div class="rating--uniform timeline-review">
                          <div
                            class="rate-star--uniform"
                            :class="
                              'rate-star--uniform-' + $options.filters.rating(product.review_stats.average_rating) * 10
                            "
                          >
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>
                          <span class="product-inline__total-review"
                            >({{ $options.filters.cnvrtNumberToK(product.review_stats.total_reviews) }})</span
                          >
                        </div>
                      </div>
                    </div>
                  </a>
                  <div v-if="equals(product.id) && product.is_reviewed !== true" class="trusted-review">
                    <SvgImg
                      id="trusted-review"
                      name="trusted-review"
                      class="trusted-review__icon"
                      width="16"
                      height="13"
                    />
                    <span class="trusted-review__text text-uppercase">TRUSTED REVIEW</span>
                  </div>
                  <div v-if="product.is_reviewed === true" class="has-reviewed">
                    <span class="red text-uppercase">REVIEWED</span>
                  </div>
                </div>
              </template>
              <infinite-loading @infinite="infiniteHandler">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
                <div slot="spinner">
                  <GLoaderSpin text="Load product.." />
                </div>
              </infinite-loading>
            </template>
            <div
              v-else-if="hasSearched && !$SO.size(searchProduct)"
              class="product-inline-listing d-flex no-filtered-product no-verified-pro"
            >
              <img src="/assets/img/icon-no-result-search.svg" loading="lazy" alt="Add review" />
              <p>Maaf, tidak ada produk yang ditemukan.</p>
            </div>
          </div>
        </div>

        <div
          v-if="isLoadingFinishRecentlyBought"
          class="list-recently-bought-container"
          :class="{ scrollable: isSeeAll }"
        >
          <div v-if="$SO.size(recentlyBought)" class="list-recently-bought">
            <p v-if="!isSeeAll" class="text-helped-pro">What Do You Love About This?</p>
            <p v-else class="text-helped-see-all">
              Bagikan pengalamanmu dan dapatkan <span>+20 SP</span> untuk
              <br />
              setiap review yang kamu bagikan!
            </p>
            <div v-if="screen.isDesktop">
              <div class="row-flex">
                <template v-for="(product, key) in recentlyBought">
                  <div
                    v-if="product.is_reviewed !== true"
                    :key="key"
                    :class="{ disabled: product.is_reviewed === true }"
                  >
                    <a href @click.prevent="selectProduct(product)">
                      <CardRecentlyBought
                        :review-data="defineReviewData(product)"
                        inline-footer
                        :is-show-rating="true"
                      />
                    </a>
                  </div>
                </template>
              </div>
            </div>
            <div v-else class="row-flex-parent">
              <div class="row-flex row-flex-child">
                <template v-for="(product, key) in recentlyBought">
                  <div
                    v-if="product.is_reviewed !== true && product.classification === 'sellable_products'"
                    :key="key"
                    class="flex-col"
                    :class="{ disabled: product.is_reviewed === true }"
                  >
                    <a href @click.prevent="selectProduct(product)">
                      <CardRecentlyBought
                        :key="`product-search-product${key}`"
                        class="product--inline"
                        :review-data="defineReviewData(product)"
                        inline-footer
                        :is-show-rating="true"
                      />
                    </a>
                  </div>
                </template>
              </div>
            </div>
            <infinite-loading v-if="paramsRecently.skip > 0" @infinite="infiniteHandlerRecently">
              <div slot="no-more"></div>
              <div slot="no-results"></div>
              <div slot="spinner">
                <GLoaderSpin text="Load product.." />
              </div>
            </infinite-loading>
          </div>
          <div v-else-if="!$SO.size(recentlyBought)" class="list-recently-bought">
            <p class="text-helped-pro">Popular Product</p>
            <div v-if="screen.isDesktop && $SO.size(trendingProducts)">
              <div class="row-flex">
                <template v-for="(product, key) in trendingProducts">
                  <div
                    v-if="product.is_reviewed !== true"
                    :key="key"
                    :class="{ disabled: product.is_reviewed === true }"
                  >
                    <a href :style="{ display: 'block', height: '100%' }" @click.prevent="selectProduct(product)">
                      <CardRecentlyBought
                        :review-data="defineReviewData(product)"
                        inline-footer
                        :is-show-rating="true"
                        :is-trending="true"
                      />
                    </a>
                  </div>
                </template>
              </div>
            </div>
            <div v-else-if="!screen.isDesktop && $SO.size(trendingProducts)" class="row-flex-parent">
              <div class="row-flex row-flex-child">
                <div
                  v-for="(product, key) in trendingProducts"
                  :key="key"
                  class="flex-col"
                  :class="{ disabled: product.is_reviewed === true }"
                >
                  <a href @click.prevent="selectProduct(product)">
                    <CardRecentlyBought :review-data="defineReviewData(product)" inline-footer :is-show-rating="true" />
                  </a>
                </div>
              </div>
            </div>
            <p v-else-if="!$SO.size(trendingProducts)">Cari produk untuk menulis review</p>
          </div>
        </div>
        <div v-else class="list-recently-bought-container">
          <div class="row-flex">
            <div v-for="i in 8" :key="i" class="flex-col">
              <GFMP :styles="{ minHeight: '72px', width: '100%', marginBottom: '10px' }" />
            </div>
          </div>
        </div>
      </form>
    </div>
  </GModal>
</template>

<script>
import debounce from 'lodash.debounce';
import { get, last } from 'lodash';

export default {
  name: 'modal-search-product',
  components: {
    CardRecentlyBought: () => import('@/components/dashboard/snippet/card-recently-bought'),
  },
  data() {
    return {
      querySearchProduct: '',
      isLoadingFinishSuggestedProduct: false,
      limit: 10,
      skip: 0,
      recentlyBought: [],
      trendingProducts: [],
      isLoadingFinishRecentlyBought: false,
      hasSearched: false,
      isLoadingSearchProduct: false,
      paramsRecently: {
        limit: 10,
        skip: 0,
        filter: {
          is_pagination: true,
        },
      },
    };
  },
  computed: {
    processingSearchProduct() {
      return this.$store.state.writeReview.processingSearchProduct;
    },
    suggestedProduct() {
      return this.$store.state.writeReview.suggestedProduct;
    },
    searchProduct() {
      return this.$store.state.writeReview.searchProduct;
    },
    colRecentlyBoughtMobile() {
      return Math.round(this.recentlyBought.length / 2);
    },
    screen() {
      return this.$store.state.screen;
    },
    productId() {
      return this.$route.params.product_id;
    },
    isSeeAll() {
      return Boolean(this.$route.query.is_see_all === 'true');
    },
    headingTitle() {
      if (!this.screen.isDesktop && this.isSeeAll) {
        return 'What Do You Love About This?';
      }
      return 'Select Product';
    },
    user() {
      return this.$store.state.auth.userProfile;
    },
  },
  created() {
    // Create debounced version of search
    this.debouncedSearch = debounce(this.performSearch, 500); // 500ms delay

    this.isLoadingFinishSuggestedProduct = false;
    this.$store
      .dispatch('getSuggestedProduct')
      .then((response) => {
        this.isLoadingFinishSuggestedProduct = true;
      })
      .catch((err) => {
        this.isLoadingFinishSuggestedProduct = true;
      });

    this.getRecentlyBought(true);
    this.getTrendingProducts();
  },
  destroyed() {
    // Cancel pending debounced calls on component destroy
    if (this.debouncedSearch) {
      this.debouncedSearch.cancel();
    }

    document.removeEventListener('click', this.documentClick);
    this.querySearchProduct = '';
    this.$store.commit('setDataSearchProduct', []);
    this.$store.dispatch('resetDataSearchProduct');
  },
  methods: {
    closeModal() {
      this.$store.dispatch('setModalSearchProduct', false);
      if (this.screen.width < 741) {
        if (/review[/]add/.test(this.$route.path)) {
          this.$router.push('/');
        }
      }
    },
    equals(id) {
      let result;
      if (this.$SO.size(this.recentlyBought)) {
        result = this.recentlyBought.filter((value) => value.id === id);
        if (result.length) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    documentClick(e) {
      const wrapperEl = this.$refs.productInlineWrapper;
      const target = e.target;

      if (wrapperEl !== target && !wrapperEl.contains(target)) {
        this.$store.dispatch('resetDataSearchProduct');
      }
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      try {
        if (!this.screen.isDesktop) {
          const elm = document.getElementsByClassName('form-search-product')[0];
          // const elm1 = document.getElementsByClassName('product-inline-wrapper')[0]
          // const elm2 = document.getElementsByClassName('form-group-search')[0]
          // const elmentes = document.getElementsByClassName('modal-body')[0]
          if (scrollTop >= 30) {
            elm.classList.add('is-fixed');
          } else {
            elm.classList.remove('is-fixed');
          }
        }
      } catch (e) {
        console.error('catch');
      }
    },
    infiniteHandler($state) {
      this.skip += this.limit;
      this.$store
        .dispatch('loadMoreSearchProduct', {
          limit: this.limit,
          skip: this.skip,
          searchValue: this.querySearchProduct,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit('mergeDataSearchProduct', response.data.data);
            if (response.data.data.length == this.limit) {
              $state.loaded();
            } else {
              $state.complete();
            }
          } else {
            this.$store.commit('mergeDataSearchProduct', []);
            $state.complete();
          }
          $state.loaded();
        })
        .catch((err) => {
          $state.complete();
          this.$store.commit('mergeDataSearchProduct', []);
        });
    },
    modalClick(e) {
      if (
        this.$refs.modalSelectProduct &&
        !this.$refs.modalSelectProduct.$el.querySelector('.modal-content').contains(e.target)
      ) {
        this.closeModal();
      }
    },
    resetSearch() {
      this.$store.dispatch('resetDataSearchProduct');
    },
    search: debounce(function (e) {
      if (!this.querySearchProduct.trim()) {
        this.$store.commit('setDataSearchProduct', []);
        this.hasSearched = false;
        return;
      }
      this.debouncedSearch();
    }, 500),
    performSearch() {
      if (!this.querySearchProduct.trim()) {
        this.$store.commit('setDataSearchProduct', []);
        this.hasSearched = false;
        return;
      }

      // First search in already loaded products (recentlyBought + trendingProducts)
      const key = new RegExp(this.querySearchProduct, 'i');
      const allLocalProducts = [...this.recentlyBought, ...this.trendingProducts];
      const localResults = allLocalProducts.filter(function (p) {
        const brandName = p.brand && p.brand.name ? p.brand.name : '';
        return key.test(p.name) || key.test(brandName);
      });

      // Then search in catalog API for additional results
      this.getProductsSearch(this.querySearchProduct, localResults);
    },
    getProductsSearch(search = '', localResults = []) {
      if (this.isLoadingSearchProduct) {
        return;
      }
      this.isLoadingSearchProduct = true;
      this.$store.commit('setProcessingSearchProduct', true);

      const params = {
        fields: 'id,images,brand,name,default_combination,combinations,is_reviewed,review_stats',
        limit: 10,
        skip: 0,
        filter: {
          $or: [
            {
              'brand.name': {
                $regex: String(search).toLowerCase(),
                $options: 'i',
              },
            },
            {
              name: {
                $regex: String(search).toLowerCase(),
                $options: 'i',
              },
            },
          ],
        },
      };

      this.$MS_CATALOG_API_URL
        .get(`/search`, { params })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            let items = response.data.data;
            items = items
              .map((res) => {
                const price = get(res, 'default_combination.price', null) || get(res, 'combinations[0].price', 0);
                if (res.default_combination && !('is_wishlist' in res.default_combination)) {
                  res.default_combination.is_wishlist = false;
                }
                res.image = get(last(res.images || []), 'url', '');
                res.manufacturer_name = get(res, 'brand.name', '');
                res.product_name = get(res, 'name', '');
                res.price = price;
                res.combination_id =
                  res.default_combination && res.default_combination._id
                    ? res.default_combination._id
                    : get(res, 'combinations[0]._id', null);
                return res;
              })
              .filter(function (item) {
                return !item.is_reviewed;
              });

            // Combine local results with API results and deduplicate
            const allResults = [...localResults, ...items];
            const uniqueResults = Array.from(
              new Map(allResults.map((product) => [product._id || product.id, product])).values()
            );
            this.$store.commit('setDataSearchProduct', uniqueResults);
            this.hasSearched = true;
          } else {
            // If API fails but we have local results, show them
            this.$store.commit('setDataSearchProduct', localResults);
            this.hasSearched = true;
          }
        })
        .catch(() => {
          // If API fails but we have local results, show them
          this.$store.commit('setDataSearchProduct', localResults);
          this.hasSearched = true;
        })
        .finally(() => {
          this.isLoadingSearchProduct = false;
          this.$store.commit('setProcessingSearchProduct', false);
        });
    },
    selectProduct(product) {
      // const notInReviewPage = !/review[/]add/.test(this.$route.path);
      // if(this.$route.path !== notInReviewPage && product.default_combination){
      this.$router
        .push({
          path: `/review/add/${product['id']}`,
          query: { ...this.$route.query, combination_id: product.default_combination._id },
        })
        .catch((err) => {});
      // } else if (this.$route.path !== notInReviewPage && !product.default_combination) {
      //   this.$router.push(`/review/add/${product['id']}`)
      // }
      this.$store.dispatch('setDataSelectedProduct', {
        dataSelectedProduct: product,
        component: this,
      });
    },
    selectSearchProduct(product) {
      // const notInReviewPage = !/review[/]add/.test(this.$route.path);
      if (!product.is_reviewed && product.id != this.$route.params.product_id) {
        this.$router.push(`/review/add/${product['id']}`).catch((err) => {
          // Handle navigation duplication error silently
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        });
        this.$store.dispatch('setDataSelectedProduct', {
          dataSelectedProduct: product,
          component: this,
        });
      } else if (product.is_reviewed) {
        this.$toasted.global.error('Kamu sudah membuat review untuk produk ini.');
      }
    },
    infiniteHandlerRecently($state) {
      if (this.isLoadingFinishRecentlyBought && this.recentlyBought.length && this.paramsRecently.skip > 0) {
        this.getRecentlyBought(false, $state);
      }
    },
    getRecentlyBought(initial = false, $state = null) {
      if (initial) {
        this.isLoadingFinishRecentlyBought = false;
      }
      let result = [];
      this.$store
        .dispatch('getRecentlyBought', { params: this.paramsRecently })
        .then((response) => {
          if (response.status === 200) {
            result = response.data.data;
            if (result && result.length >= this.paramsRecently.limit) {
              this.paramsRecently.skip += this.paramsRecently.limit;
              if ($state) {
                $state.loaded();
              }
            } else {
              this.paramsRecently.skip = -1;
              if ($state) {
                $state.complete();
              }
            }
            this.$SO.each(result, (keyData, data) => {
              if (this.$SO.size(data.combinations)) {
                this.$SO.each(result[keyData].combinations, (key, combination) => {
                  result[keyData].combinations[key].attribute = result[keyData].combinations[key].attributes;
                });
              }
            });

            for (let i = 0; i < result.length; i++) {
              for (let j = 0; j < this.recentlyBought.length; j++) {
                if (result[i]['id'] === this.recentlyBought[j]['id']) {
                  result.splice(i, 1);
                }
              }
            }
            this.recentlyBought = this.recentlyBought.concat(result);
          } else {
            this.recentlyBought = [];
            this.paramsRecently.skip = -1;
            if ($state) {
              $state.complete();
            }
          }
          this.isLoadingFinishRecentlyBought = true;
        })
        .catch((err) => {
          console.error(err);
          this.recentlyBought = [];
          this.isLoadingFinishRecentlyBought = true;
          this.paramsRecently.skip = -1;
          if ($state) {
            $state.complete();
          }
        });
    },
    getTrendingProducts() {
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/v2/products/featured/trending`, {
          params: {
            filter: {
              is_reviewed: true,
              exclude_reviewed_products: true,
            },
            section: 'TrendingProducts',
          },
        })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            const items = response.data.data;
            this.trendingProducts = items.map((res) => {
              if (res.default_combination && !('is_wishlist' in res.default_combination)) {
                res.default_combination.is_wishlist = false;
              }
              return res;
            });
          } else {
            this.trendingProducts = [];
          }
        })
        .catch((err) => {
          this.trendingProducts = [];
        });
    },
    defineReviewData(product) {
      return {
        ...product,
        product_name: product.name,
        manufacturer_name: product.brand && product.brand.name ? product.brand.name : '',
        image: product.images && product.images.length > 0 ? product.images[0].url : '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;

  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #b32656;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 12px;
  }

  p {
    font-size: 14px;
    color: #716a68;
    margin: 0;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.no-results-search {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;

  .no-results-icon {
    margin-bottom: 16px;

    img {
      width: 80px;
      height: 80px;
    }
  }

  .no-results-text {
    font-size: 14px;
    font-weight: 400;
    color: #716a68;
    margin: 0;
    line-height: 1.4;
  }
}

.disabled {
  pointer-events: none;
  opacity: 0.6;
}
.card-recently-bought {
  width: 100% !important;
}
.text-empty-product {
  font-size: 16px;
  line-height: 22px;
  color: #8c8582;
  font-family: 'lato-regular';
  margin-bottom: 8px;
  margin: 0 auto;
  text-align: center;
}
.list-recently-bought {
  .row-flex {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    > div {
      flex: 0 0 calc(50% - 6px);
      max-width: calc(50% - 6px);

      a {
        display: block;
        height: 100%;
      }
    }
  }
  .row-flex-parent {
    width: 100%;

    .row-flex {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;

      &.row-flex-child {
        width: 100%;
      }
    }

    .flex-col {
      flex: 1;
      min-width: 280px;
      max-width: 100%;

      @media (min-width: 768px) {
        flex: 0 0 calc(50% - 6px);
        max-width: calc(50% - 6px);
      }

      @media (min-width: 1024px) {
        flex: 0 0 calc(33.333% - 8px);
        max-width: calc(33.333% - 8px);
      }

      a {
        display: block;
        height: 100%;
      }
    }
  }
}
.list-recently-bought-container {
  .row-flex {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .flex-col {
      flex: 1;
      min-width: 280px;

      @media (min-width: 768px) {
        flex: 0 0 calc(50% - 6px);
        max-width: calc(50% - 6px);
      }

      @media (min-width: 1024px) {
        flex: 0 0 calc(33.333% - 8px);
        max-width: calc(33.333% - 8px);
      }
    }
  }
}
</style>
